export default {
      id: "event-catalog-placement-header-usage",
      viewBox: "0 0 63 67",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#event-catalog-placement-header",
      toString: function () {
        return this.url;
      }
    }